import {TableCell, styled} from '@mui/material'

const StyledTableHead = styled(TableCell)(() => ({
    fontSize: '16px',
    fontWeight: 'bold',
    fontFamily: 'Poppins',
    padding: "10px"
}));



export default StyledTableHead